"use strict";import{tag as a}from"../custom-tag.js";export function spreadsheetIcon({height:e=16,width:t=16,hidden:s=!1,title:r="Spreadsheet"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${s?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <mask
        id="spreadsheet_svg__mask0_6875_6625"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M14 18h8v4h-8zM2 18h8v4H2zM14 2h8v4h-8zM2 2h8v4H2zm12 8h8v4h-8zM2 10h8v4H2z"
        />
      </mask>
      <g mask="url(#spreadsheet_svg__mask0_6875_6625)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=spreadsheet.js.map
